module.exports = __webpack_public_path__ + "img/icon-sb-mattress-returns-48.76ba0d3.svg";